import React from 'react'
import PropTypes from 'prop-types'

const DigitalTemplateEnabledFeature = (props) => {
  const {
    children, digitalTemplate: { options }, featureKey = 'print_version', renderDisabled,
  } = props

  const { features } = options || {}

  const permitted = features && features.find(feature => feature.key === featureKey)

  if (!permitted) return renderDisabled ? renderDisabled() : null

  return children
}

DigitalTemplateEnabledFeature.propTypes = {
  children: PropTypes.node.isRequired,
  digitalTemplate: PropTypes.object.isRequired,
  featureKey: PropTypes.string,
  renderDisabled: PropTypes.func,
}

export default DigitalTemplateEnabledFeature
